import { useTranslation } from "react-i18next";

const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <section className="relative px-6 overflow-hidden" aria-labelledby="hero-title">
      <div className="max-w-[1400px] mx-auto flex flex-col min-h-[calc(100svh-73px)] py-10">
        {/* Top annotation row */}
        <div className="hidden md:flex items-center justify-between ed-eyebrow text-muted-foreground animate-fade-in">
          <span className="inline-flex items-center gap-2">
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-brand ed-blink" />
            {t("common.studio")}
          </span>
          <span>{t("common.madeInBrazil")}</span>
        </div>

        {/* Giant statement */}
        <div className="flex-1 flex flex-col justify-center py-10">
          <h1 id="hero-title" className="ed-mega text-center animate-fade-in">
            <span className="block">{t("hero.line1")}</span>
            <span className="block">
              {t("hero.line2")}
              <span className="text-brand">.</span>
            </span>
          </h1>
        </div>

        {/* Bottom row - serif annotation + actions */}
        <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
          <p className="ed-serif text-2xl md:text-3xl max-w-md text-foreground/85 animate-fade-in-delay-1">
            {t("hero.sub")}
          </p>

          <div className="flex flex-wrap gap-3 animate-fade-in-delay-2">
            <a href="/products" className="ed-btn ed-btn-solid">
              {t("common.exploreProducts")}
            </a>
            <a href="/contact" className="ed-btn">
              {t("common.getInTouch")}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
